import { useCallback, useState } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';
import { useDialog } from 'hooks/useDialog';

import { PersistentLinkDialog, PersistentLinkErrorDialog } from './PersistentLinkDialog';

const ShareButton = () => {
  const [link, setLink] = useState<string>();
  const { setDialog, unsetDialog } = useDialog();

  const configurationData = useAppSelector((state: RootState) => state.configuration.data);

  const fetchPersistentUrl = useCallback(async () => {
    const pubShareUrl = `${configurationData?.pubUrl}/dela?app_link=`;

    let windowLocation =
      process.env.NODE_ENV === 'development'
        ? `https://u-app.testraa.se/open/bebyggelse${location.pathname}`
        : window.location.href;

    // Ta bort eventuella queryparametrar, ex. facebooks trackingparametrar
    // som förstör skapandet av den persistenta länken
    windowLocation = windowLocation.split('?')[0];
    return await fetch(`${pubShareUrl}${windowLocation}`);
  }, [configurationData?.pubUrl]);

  const copyPersistantLinkToClipBoard = async () => {
    if (link) {
      setDialog(PersistentLinkDialog, { link, unsetDialog });
      return;
    }

    try {
      const response = await fetchPersistentUrl();

      if (!response.ok) {
        throw new Error(`Kunde inte skapa persistent länk (status ${response.status}, message ${response.statusText})`);
      }

      const link = await response.text();

      setLink(link);
      setDialog(PersistentLinkDialog, { link, unsetDialog });
    } catch (e) {
      setDialog(PersistentLinkErrorDialog, { unsetDialog });
    }
  };

  return (
    <button className="raa-link" onClick={copyPersistantLinkToClipBoard}>
      <span className="tw-mr-1 raa-icon raa-icon-share" />
      <span>Dela</span>
    </button>
  );
};

export default ShareButton;
